<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                title="新增通知"
                :visible.sync="show"
                width="1000px" >
            <div style="width: 100%; height: 100%;" v-loading="loading">
                <div class="w100 pl5 pr20 pt20 pb20">
                    <el-form label-width="120px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
                        <el-form-item label="名称" prop="name" style="min-width: 250px;">
                            <el-input v-model="form.name" placeholder="请输入主题名称"></el-input>
                        </el-form-item>
                        <el-form-item label="过期时间" prop="overTime" style="min-width: 250px;">
                            <el-date-picker
                                    placeholder="选择结束时间"
                                    value-format="yyyy-MM-dd"
                                    v-model="form.overTime"
                                    type="date"
                                    :editable="false"
                                    :picker-options="pickerOptions"
                                    style="width: 100%!important;"></el-date-picker>

                        </el-form-item>
                        <el-form-item label="类型" prop="noticeType" style="min-width: 250px;">
                            <el-select v-model="form.noticeType"  placeholder="请选择" class="w100">
                                <el-option
                                        v-for="item in noticeTypeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发起内容" prop="content" style="min-width: 250px;">
                            <quillEditorCom v-model="form.content"  />
                        </el-form-item>
                        <el-form-item label="发起部门" prop="launchDeptId" style="min-width: 250px;">
                            <TreeSelect size="small"
                                        :data="departmentData"
                                        clearable
                                        v-if="show"
                                        expandAll
                                        ref="deptSingle"
                                        :obj="mapKey"
                                        checkStrictly
                                        @getValue="setDeptSingleMenu">
                            </TreeSelect>

                        </el-form-item>
                        <el-form-item label="通知类型" prop="type" style="min-width: 250px;">
                            <el-select v-model="form.type"  placeholder="请选择" class="w100">
                                <el-option
                                        v-for="item in typeList"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="通知范围(人员)：" prop="userList" v-show="form.type==1">
                            <el-input
                                    placeholder="请选择成员"
                                    style="width: 440px"
                                    v-model="userText"
                                    disabled
                            ></el-input>
                            <el-button type="primary" style="margin-left:10px"  @click="addUser">+添加</el-button>
                        </el-form-item>
                        <div>
                            <el-form-item label="通知部门策略" prop="deptStrategy" style="min-width: 250px;" v-show="form.type==2">
                                <el-select v-model="form.deptStrategy"  placeholder="请选择" class="w100">
                                    <el-option
                                            v-for="item in deptStrategyList"
                                            :key="item.value"
                                            :label="item.name"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <el-form-item label="通知范围(部门)" prop="deptList" style="min-width: 250px;" v-show="form.type==2">
                            <TreeSelect size="small" :data="departmentData"
                                        v-if="show"
                                        clearable
                                        multiple
                                        expandAll
                                        ref="deptDouble"
                                        :obj="mapKey"
                                        checkStrictly
                                        @getValue="setDeptDoubleMenu">
                            </TreeSelect>
                        </el-form-item>
                        <el-form-item label="附件：" >
                            <div >
                                <el-upload
                                        class="upload-demo"
                                        action="#"
                                        :file-list="filelist"
                                        :before-remove="beforeRemoveFn"
                                        :before-upload="beforeUploadFn"
                                >
                                    <el-button slot="trigger">
                                        <i class="el-icon-upload"></i>
                                    </el-button>

                                </el-upload>

                            </div>
                        </el-form-item>

                    </el-form>

                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>

        </el-dialog>
        <charge-person
                ref="personModal"
                :personData="personData"
                @closePerson="closePerson"
        />
    </div>
</template>

<script>

    import { addNoticeSave} from '@/api/managementCenter/notification';
    import { remote } from '@/api/admin/dict';
    import quillEditorCom from '@/components/common/quillEditor.vue'
    import { sysFileUpload,sysFileDelete} from '@/api/managementCenter/otherApi';
    import TreeSelect from "@/components/TreeSelect.vue";
    import  chargePerson from "@/components/management/reportManage/chargePerson.vue";
    import { getDeptTree} from '@/api/managementCenter/otherApi';
    export default {
        name: "notifyDialog",
        components: {
            quillEditorCom,
            chargePerson,
            TreeSelect
        },
        props: [],
        data() {

            let valiUserPass = (rule, value, callback) => {
                if ((value === ""|| value.length==0)&&this.form.type==1) {
                    callback(new Error("请选择人员"));
                } else {
                    callback();
                }
            };
            let valiStrategyPass = (rule, value, callback) => {
                if ((value === ""|| value.length==0)&&this.form.type==2) {
                    callback(new Error("请选择通知部门策略"));
                } else {
                    callback();
                }
            };
            let valiDeptPass = (rule, value, callback) => {
                if ((value === ""|| value.length==0)&&this.form.type==2) {
                    callback(new Error("请选择部门"));
                } else {
                    callback();
                }
            };
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 86400000;
                    },
                },
                typeList:[
                    {
                        name:'请选择',
                        value:''
                    },
                    {
                        name:'人员',
                        value:'1'
                    },
                    {
                        name:'部门',
                        value:'2'
                    },
                    {
                        name:'全校',
                        value:'3'
                    }
                ],
                deptStrategyList:[
                    {
                        name:'请选择',
                        value:''
                    },
                    {
                        name:'本部门',
                        value:'1'
                    },
                    {
                        name:'包含下级部门',
                        value:'2'
                    }
                ],
                userText:'',
                userId:[],
                show: false,
                loading: false,
                personData: {
                    userData: [],
                    state: false,
                    disabled: false,
                    data: null
                },
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                departmentData:[],
                deptList:[],
                filelist:[],
                noticeTypeList:[],
                form: {
                    name: "",
                    overTime: "",
                    content: "",
                    type:"",
                    launchDeptId:'',
                    userList:[],
                    noticeType:[],
                    deptStrategy:"",
                    deptList:[],
                    attachIds:[]
                },
                rules: {
                    name: [
                        { required: true, message: "请输入通知名称", trigger: "blur" }
                    ],
                    overTime: [
                        { required: true, message: "请选择通知时间", trigger: "change" }
                    ],
                    noticeType: [
                        { required: true, message: "请选择类型", trigger: "change" }
                    ],
                    content: [
                        { required: true, message: "请输入通知内容", trigger: "change" }
                    ],
                    type: [
                        { required: true, message: "请选择通知类型", trigger: "change" }
                    ],
                    launchDeptId: [
                        { required: true, message: "请选择发起部门", trigger: "change" }
                    ],
                    userList: [
                        { validator: valiUserPass, trigger: "change" }
                    ],
                    deptStrategy: [
                        { validator: valiStrategyPass, trigger: "change" }
                    ],
                    deptList: [
                        { validator: valiDeptPass, trigger: "change" }
                    ]
                }
            };
        },
        computed: {

        },
        methods: {
            beforeRemoveFn(file) {
                if(!file.id){
                    return;
                }
                this.deleteFile(file.id,()=>{
                    this.filelist =this.filelist.filter(i=>{
                        return file.id!=i.id
                    })
                })
            },
            deleteFile(id,callback){
                sysFileDelete(id).then(({data}) => {
                    if(data.code == 0){
                        callback&&callback()
                        this.$message.success(  "删除成功!" );
                    }else{
                        this.$message.warning( data.msg||"删除失败！" );
                    }
                }).catch(err=>{
                    this.$message.error( "删除异常!" );
                })
            },
            // 上传文件之前的方法
            beforeUploadFn(file){

                const isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    this.$message.error('上传附件大小不能超过20MB!');
                    return isLt2M
                }
                let fd = new FormData();
                fd.append('fromTarget',0)
                fd.append('file',file);
                //上传到后台
                this.loading=true
                sysFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.$message.success(  "上传文件成功!" );
                        this.filelist.push(
                            {
                                ...data.data,
                                name:data.data.fileName

                            }
                        )
                    }else{
                        this.$message.warning( data.msg|| "上传文件失败!" );
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error(  "上传文件异常!" );
                });
            },
            //获取部门数据
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        if(data.data&&data.data.length>0) {
                            if(data.data[0].id==1){
                                this.departmentData = data.data[0].children;
                            }else{
                                this.departmentData = data.data
                            }
                        }
                    }
                }).catch(err=>{

                })
            },
            //获取类型
            remoteFn(){
                remote('notice_type').then(({data})=>{
                    if(data.code == 0){
                                this.noticeTypeList = data.data||[];
                            }else{
                        this.$message.warning( data.msg|| "获取类型失败!" );
                            }
                }).catch(err=>{
                    this.$message.error( data.msg|| "获取类型异常!" );
                })

            },
            // 显示弹框
            dialogShow () {
                // 重置表单、显示弹框
                this.show = true;
                this.$nextTick(function(){
                    this.$refs["ruleForm"].resetFields();
                });
            },
            addNoticeSaveFn(){
                this.form.attachIds=this.filelist.map(i=>i.id);
                this.loading = true;
                let params=JSON.parse(JSON.stringify(this.form));
                if(params.type==1||params.type==3){
                    params.deptStrategy="";
                    params.deptList=[];
                };
                if(params.type==2||params.type==3){
                    params.userList=[]
                };
                params.overTime+=" 23:59:59";
                addNoticeSave(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "添加通知成功!" );
                        this.show=false
                        this.$emit('saveSuccess')
                    }else{
                        this.$message.warning(  data.msg||"添加通知失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },
            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addNoticeSaveFn()
                    } else {
                        return false;
                    }
                });
            },
            setDeptSingleMenu(key,data){//获取子组件值
                this.form.launchDeptId = data.id;
            },
            setDeptDoubleMenu(key,data){//获取子组件值
                this.deptList = (data||[]).map(item=>item.id);
            },
            //显示人员选择
            addUser() {
                this.personData.state = true;
            },
            //选择人员
            closePerson(value) {
                if (!value.mans) {
                    this.personData.state = false;
                    return;
                }
                let mans=value.mans||[];
                this.userText= (mans.map(item=>item.name)).join("、");
                this.userId= mans.map(item=>item.userId);
                this.personData.state = false;
            },
        },
        watch: {

            deptList(val){
                this.form.deptList=(val||[]).map(i=>{
                    return {deptId:i};
                })
            },
            userId(val){
                this.form.userList=(val||[]).map(i=>{
                    return {userId:i};
                })
            },
            show(value){
                if(!value){
                    this.userText="";
                    this.userId=[];
                    this.deptList=[];
                    this.form={
                        name: "",
                        content: "",
                        type:"",
                        launchDeptId:'',
                        userList:[],
                        deptStrategy:"",
                        overTime:'',
                        deptList:[],
                        attachIds:[],
                        noticeType:[]
                    };
                }else{
                    this.getDeptTreeData();
                    this.remoteFn();
                }

            }
        },

        filters: {}
    };
</script>

<style scoped lang="less">

</style>
